import { render, staticRenderFns } from "./synchronizedFieldsWindow.vue?vue&type=template&id=4491d412&"
import script from "./synchronizedFieldsWindow.vue?vue&type=script&lang=js&"
export * from "./synchronizedFieldsWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4491d412')) {
      api.createRecord('4491d412', component.options)
    } else {
      api.reload('4491d412', component.options)
    }
    module.hot.accept("./synchronizedFieldsWindow.vue?vue&type=template&id=4491d412&", function () {
      api.rerender('4491d412', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/synchronizedFieldsWindow.vue"
export default component.exports